import styled from '@emotion/styled';
import { CSSObject } from '@emotion/react';
import theme from '../../theme';

// eslint-disable-next-line import/prefer-default-export

export const basicLinkStyles = {
  color: theme.colors.darkBlue,
  textDecoration: 'none',
  position: 'relative',

  '&:after': {
    borderBottom: `1px solid ${theme.colors.darkBlue}`,
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: -1,
    height: 1,
    width: '100%',
    willChange: 'transform',
    transform: 'scaleX(0)',
    transformOrigin: 'right center',
    transition: `transform .4s ${theme.transitionTimingFunctions.easeInOut} 0s`,
  },

} as CSSObject;

export const hoverLinkStyles = {
  textDecoration: 'none',

  '&:after': {
    transformOrigin: 'left center',
    transform: 'scaleX(1)',
  },
} as CSSObject;

export const Anchor = styled.a({
  ...basicLinkStyles,

  ':hover': hoverLinkStyles,

  ':visited': {
    color: theme.colors.darkBlue,
  },

});
